import api from './api'
import type { Company } from '@/types/company'

export async function getCompanies(): Promise<Company[]> {
  const { data } = await api.get('/companies/')
  return data
}

export async function getCompanyById(id: string): Promise<Company> {
  const { data } = await api.get(`/companies/${id}`)
  return data
}

export async function createCompany(payload: Partial<Company>): Promise<Company> {
  const { data } = await api.post('/companies/', payload)
  return data
}

export async function updateCompany(id: string, payload: Partial<Company>): Promise<Company> {
  const { data } = await api.put(`/companies/${id}`, payload)
  return data
}

export async function deleteCompany(id: string): Promise<Company> {
  const { data } = await api.delete(`/companies/${id}`)
  return data
}
